//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex';
import ErrorDisplay from '../../../../common/ErrorDisplay.vue';
import Checkbox from '../../../../common/svg/Checkbox.vue';
import Logo from '../../../../common/svg/Logo.vue';
import { stepsArray, stepsEnum } from './steps';

import RegistrationStepAccountModal from './modals/RegistrationStepAccountModal.vue';
import RegistrationStepTermsAndConditionsModal from './modals/RegistrationStepTermsAndConditionsModal.vue';
import RegistrationStepUserDetails from './modals/RegistrationStepUserDetails.vue';
import RegistrationStepSoulFocus from './modals/RegistrationStepSoulFocus.vue';

export default {
  name: 'OptinRegistration',
  components: {
    ErrorDisplay,
    Checkbox,
    Logo,
    RegistrationStepAccountModal,
    RegistrationStepTermsAndConditionsModal,
    RegistrationStepUserDetails,
    RegistrationStepSoulFocus,
  },

  created() {
    this.pageTitle = 'Landing Page';
    this.description = 'Description';
    this.instructionsTitle = this.instructionsTitle;
    this.steps = stepsArray.filter(step => this.$route.meta.steps.includes(step.ref));
  },

  data() {
    return {
      pageTitle: '',
      pageState: '',
      description: '',
      instructionsTitle: '',
      loading: false,
      error: null,
      steps: null,
    };
  },

  methods: {
    ...mapActions(['initialize', 'updatePayment']),

    async registerNow() {
      if (!this.loading) {
        this.pageState = 'Registering to event...';
        this.loading = true;
        this.error = null;
        try {
          if (this.isEvent) {
            const resp = await this.addUserToDistributedEvent();
            if (resp === 'success') {
              await this.initialize();
              window.location.replace(this.customUrl);
            } else {
              throw resp;
            }
          } else {
            await this.addUserToCohort();
            await this.initialize();
            if (this.isNewUser) {
              await this.$router.push({ name: 'setup' });
            } else {
              await this.$router.push({ name: 'dashboard' });
            }
          }
        } catch (error) {
          console.log(error);
          this.handleError(error);
        } finally {
          this.loading = false;
          this.pageState = '';
        }
      }
    },

    async addUserToCohort() {
      try {
        this.pageState = `Syncing to ${this.cohortName} ...`;
        await this.$container.dao.addUserToCohort(
          this.loggedInMember.memberId,
          this.cohortId,
          this.permission,
        );
      } catch (error) {
        this.error = error;
      } finally {
        this.pageState = null;
      }
    },

    async addUserToDistributedEvent() {
      let response;
      try {
        await this.initialize();
        this.pageState = `Registering to ${this.eventName}`;
        const userData = this.steps.find(step => step.ref === stepsEnum.USER_DETAILS || step.ref === stepsEnum.SOUL_FOCUS).completed;
        if (!userData) {
          throw new Error('Step not completed');
        }
        const data = {
          emailAddress: userData.emailAddress,
          firstName: userData.firstName,
          lastName: userData.lastName,
          gender: userData.gender,
          birthDate: userData.birthDate,
        };
        if ('teamName' in userData) data.teamName = userData.teamName;
        response = await this.$api.registerUserWithEvent(data, this.eventId);
        if (response.data.message !== 'success') {
          if (response.data.message) {
            return `${response.data.message}. For assistance, please contact team@pwrlab.com`;
          }
          return 'please refresh the page and try again. If error persists, please contact team@pwrlab.com';
        }
        return response.data.message;
      } catch (error) {
        console.log(error);
        this.error = error;
        return error;
      } finally {
        this.pageState = null;
      }
    },

    handleError(error) {
      if (error.response && error.response.data) {
        this.error = error.response.data;
      } else {
        this.error = error;
      }
      this.loading = false;
    },

    launch(from) {
      this.$refs[from][0].launch();
    },
  },

  computed: {
    ...mapGetters(['user', 'loggedInMember']),
    areStepsCompleted() {
      return !this.steps.some(step => step.completed === null);
    },

    isNewUser() {
      return this.steps.some(step => step.completed === 'new');
    },

    isEvent() {
      return !!this.$route.meta.isEvent;
    },

    cohortName() {
      return this.$route.meta.cohortName;
    },

    eventName() {
      return this.$route.meta.isEvent ? this.$route.meta.cohortName : null;
    },

    cohortId() {
      return this.$route.meta.cohortId;
    },

    eventId() {
      return this.$route.meta.isEvent ? this.$route.meta.cohortId : null;
    },

    customUrl() {
      return this.$route.meta.customUrl;
    },

    permission() {
      return this.$route.meta.permission;
    },

    middle() {
      return this.$route.meta.middle;
    },

    banner() {
      return this.$route.meta.banner;
    },

    config() {
      return this.$route.meta.config;
    },
  },
};
